import gql from 'graphql-tag';

export const DEACTIVATE_ALTERNATE_TEMPLATE = gql`
  mutation deactivateAltTemplate($providerTemplateId: Int!) {
    deactivateAltTemplate(providerTemplateId: $providerTemplateId) {
      id
    }
  }
`;
